import { render, staticRenderFns } from "./RecursosPagina.vue?vue&type=template&id=a0ba32b6&scoped=true"
import script from "./RecursosPagina.vue?vue&type=script&lang=js"
export * from "./RecursosPagina.vue?vue&type=script&lang=js"
import style0 from "./RecursosPagina.vue?vue&type=style&index=0&id=a0ba32b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ba32b6",
  null
  
)

export default component.exports